import { calculateDecimalAIBW } from './aibw.js';
import { calculateDecimalBSA } from './bsa.js';
/**
 * The weight weight-based doses (WEIGHT, BSA30) are calculated with: the AIBW when the patient's
 * "Use AIBW" switch is on, as in old Cypro, otherwise the real weight. With the switch on and no
 * AIBW the weight counts as missing, so the dose is never silently calculated on the real weight.
 */
export function getDosingWeight(characteristics) {
    if (!characteristics?.useAibw)
        return characteristics?.weight ?? null;
    const aibw = characteristics.aibw;
    return aibw != null && aibw > 0 ? aibw : null;
}
/** AIBW and BSA for the characteristics dialog; with "Use AIBW" on the BSA is calculated from the AIBW, as in old Cypro. */
export function calculateBodyMeasures(params) {
    const { height, weight, sex, useAibw, bsaFormula, aibwFormula } = params;
    const aibw = calculateDecimalAIBW(height, weight, sex, 4, aibwFormula);
    const bsa = calculateDecimalBSA(height, useAibw ? aibw : weight, 4, bsaFormula);
    return { aibw, bsa };
}
/** Whether "Use AIBW" is on without an AIBW to dose with; the characteristics dialog and mutator reject it. */
export function isAibwMissing(characteristics) {
    return Boolean(characteristics?.useAibw) && !(characteristics?.aibw != null && characteristics.aibw > 0);
}
//# sourceMappingURL=dosing-weight.js.map